// ⭐ 2 nov 2026 (Deepscope, snelheid): zonder jQuery, zelfde gedrag als de jQuery-versie (één item open per lijst,
// in- en uitschuiven in 300 ms; de CSS verbergt .collapsible-content__answer met display:none).
(function () {
	const DUUR = 300;
	const toon = (el) => {
		el.style.display = 'block';
		const h = el.scrollHeight;
		el.style.overflow = 'hidden';
		el.style.height = '0px';
		el.getBoundingClientRect();
		el.style.transition = 'height ' + DUUR + 'ms ease';
		el.style.height = h + 'px';
		setTimeout(() => { el.style.height = ''; el.style.overflow = ''; el.style.transition = ''; }, DUUR);
	};
	const verberg = (el) => {
		if (getComputedStyle(el).display === 'none') return;
		const h = el.scrollHeight;
		el.style.overflow = 'hidden';
		el.style.height = h + 'px';
		el.getBoundingClientRect();
		el.style.transition = 'height ' + DUUR + 'ms ease';
		el.style.height = '0px';
		setTimeout(() => { el.style.display = 'none'; el.style.height = ''; el.style.overflow = ''; el.style.transition = ''; }, DUUR);
	};
	const initCollapsibleContent = () => {
		document.querySelectorAll('.collapsible-content__toggle').forEach((toggle) => {
			if (toggle.dataset.dsInit) return;
			toggle.dataset.dsInit = '1';
			toggle.addEventListener('click', () => {
				const parent = toggle.parentElement;
				const lijst = toggle.closest('.collapsible-content__items');
				const antwoord = toggle.nextElementSibling;
				const wasOpen = parent.classList.contains('active');
				if (lijst) {
					lijst.querySelectorAll('.collapsible-content__item.active').forEach((item) => { if (item !== parent) item.classList.remove('active'); });
					lijst.querySelectorAll('.collapsible-content__answer').forEach((a) => { if (a !== antwoord) verberg(a); });
				}
				if (wasOpen) {
					parent.classList.remove('active');
					if (antwoord) verberg(antwoord);
				} else {
					parent.classList.add('active');
					if (antwoord) toon(antwoord);
				}
			});
		});
	};
	document.addEventListener('shopify:section:load', initCollapsibleContent);
	initCollapsibleContent();
})();
